/**
 * Generates HEX color between two different color based on the percentage provided.
 */
export function perc2color(ratio, endColor, startColor) {
  startColor = startColor.replace('#', '');
  endColor = endColor.replace('#', '');

  const hex = function (x) {
    x = x.toString(16);
    return x.length === 1 ? '0' + x : x;
  };

  const r = Math.ceil(
    parseInt(endColor.substring(0, 2), 16) * ratio +
      parseInt(startColor.substring(0, 2), 16) * (1 - ratio)
  );
  const g = Math.ceil(
    parseInt(endColor.substring(2, 4), 16) * ratio +
      parseInt(startColor.substring(2, 4), 16) * (1 - ratio)
  );
  const b = Math.ceil(
    parseInt(endColor.substring(4, 6), 16) * ratio +
      parseInt(startColor.substring(4, 6), 16) * (1 - ratio)
  );

  return `#${hex(r) + hex(g) + hex(b)}`;
}

export default {
  perc2color,
};
